import { config } from "../../util/axios-config";
import triyoAPI from "./triyo";

export const GetActiveTasksForTelerikGrid = (data) => {
  return triyoAPI.get(
    `/Tasks/GetUserTasksForTelerikGrid?type=${data}`,
    config()
  );
};

export const GetActiveTasksForConfigurableTelerikGrid = (data) => {
  return triyoAPI.get(
    `/Tasks/GetUserTasksForConfigurableTelerikGrid?type=${data}`,
    config()
  );
};

export const GetTaskForConfigurableTelerikGrid = (taskId) => {
  return triyoAPI.get(
    `/Tasks/GetTaskForConfigurableTelerikGrid?taskId=${taskId}`,
    config()
  );
};

export const SubmitTaskFormDueDates = (data) => {
  return triyoAPI.post(
    `/Tasks/SubmitTaskFormDueDates`,
    data,
    config("POST")
  );
};

export const GetTasksCountForTelerikGrid = (data) => {
  return triyoAPI.get(
    `/Tasks/GetTotalTasksCount?areDocumentTasksRequired=${data}`,
    config()
  );
};

export const DownloadDynamicFormFieldFile = (fileId) => {
  return triyoAPI.get(
    `/Tasks/DownloadDynamicFormFieldFile?fileId=${fileId}`,
    { ...config()}
  );
}
